import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ExportParameterConfig } from "./config/export-query-types";

interface ExportParameterInputProps {
    config: ExportParameterConfig;
    value: any;
    onChange: (value: any) => void;
}

export function ExportParameterInput({ config, value, onChange }: ExportParameterInputProps) {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let newValue: any = e.target.value;

        if (config.type === "number") {
            newValue = newValue === "" ? undefined : parseInt(newValue, 10);
        } else if (config.type === "datetime") {
            if (newValue) {
                // Convert datetime-local input to the expected format
                newValue = new Date(newValue).toISOString().replace('T', ' ').slice(0, 19);
            }
        }

        onChange(newValue);
    };

    const getInputValue = () => {
        if (config.type === "datetime" && value) {
            // Convert the stored datetime string back to datetime-local format
            return new Date(value).toISOString().slice(0, 16);
        }
        if (config.type === "number") {
            return value !== undefined ? value.toString() : "";
        }
        return value || "";
    };

    const getInputType = () => {
        switch (config.type) {
            case "number":
                return "number";
            case "datetime":
                return "datetime-local";
            case "email":
                return "email";
            default:
                return "text";
        }
    };

    return (
        <div className="space-y-2">
            <Label htmlFor={config.key}>
                {config.label}
                {config.required && <span className="text-red-500 ml-1">*</span>}
            </Label>
            <Input
                id={config.key}
                type={getInputType()}
                value={getInputValue()}
                onChange={handleChange}
                placeholder={config.placeholder}
                min={config.validation?.min}
                max={config.validation?.max}
                pattern={config.validation?.pattern}
                required={config.required}
            />
        </div>
    );
}
